import { clientFetch } from 'app/utils/client-fetch';
import { RomListSearchCriteria } from './interfaces';
import * as types from './types';
import config from 'app/config';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const apiGetRoms = (criteria?: RomListSearchCriteria) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/roms`,
        type: types.GET_ROMS
    });
};
